<div class="form__group" [class.mb-0]="withMb0">
  <label class="form__checkbox" [ngClass]="'form__checkbox_'+icon" [class.form__checkbox_border]="border">
    <input type="checkbox" (change)="onChanges()" [checked]="current_value" [disabled]="disabled">
    @if (current_value && disabled) {
      <span class="form__checkbox__wrapper__true">
        <span class="form__checkbox__wrapper__toggler icon" [ngClass]="[icon]"></span>
      </span>
    } @else {
      <span class="form__checkbox__wrapper">
        <span class="form__checkbox__wrapper__toggler icon" [ngClass]="[icon]"></span>
      </span>
    }
    <span class="form__checkbox__content"><ng-content></ng-content></span>
  </label>
</div>
